import api from "./api";

const episodeService = {};
const getEndpoint = ({ patientId }) => {
  return `/episodes/patients/${patientId}`;
};

episodeService.createEpisodeTreatment = function ({
  patientId,
  treatmentId,
  startsAt,
}) {
  const endpoint = getEndpoint({ patientId });
  return api
    .post(`${endpoint}/treatments`, {
      treatment: treatmentId,
      startsAt,
    })
    .then((res) => res.data);
};

episodeService.removeEpisodeTreatment = function ({
  patientId,
  episodeTreatmentId,
}) {
  const endpoint = getEndpoint({ patientId });
  return api
    .delete(`${endpoint}/treatments/${episodeTreatmentId}`)
    .then((res) => res.data);
};

episodeService.create = function (patientId, data) {
  return api.post(getEndpoint({ patientId }), data).then((res) => res.data);
};

episodeService.get = function (patientId, query = {}) {
  return api
    .get(getEndpoint({ patientId }), { params: query })
    .then((res) => res.data);
};

episodeService.getActive = function (patientId, query = {}) {
  return api.get(getEndpoint({ patientId }), { params: query }).then((res) =>
    res.data.docs.find(
      ({ status }) => status === "active" // There should at least one active episode (For now only one)
    )
  );
};

export default episodeService;
